<template>
  <DropdownButton text="見積リスト" size="font-bold text-white rounded bg-transparent" :menus="menu" @select="select">
    <LoadingIcon v-if="isLoading" slot="before" class="h-4 w-4" />
    <Icon v-if="!isLoading" iconName="ViewList" slot="before" class="h-4 w-4" />
    <Icon iconName="ChevronDown" slot="after" class="h-4 w-4" />
  </DropdownButton>
</template>

<script>
import DropdownButton from '@components/DropdownButton.vue'
import Icon from '@components/Icon.vue'
import LoadingIcon from '@assets/loading-circle.svg' 

const menu = [
  {
    value: 'list',
    text: '見積一覧'
  },
  {
    value: 'approval',
    text: '承認待ち一覧'
  },
]

export default {
  components: {
    DropdownButton,
    Icon,
    LoadingIcon
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu
    }
  },
  methods: {
    select(menuItem) {
      this.$emit('select', menuItem.value)
    }
  }
}
</script>